module.exports = __webpack_public_path__ + "46e2de457c836955e265e05dffdde11b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio2/das_zimmer_holder.jpg
// module id = 229
// module chunks = 0